module.exports = "/Public/build/5fe8ec10493131a7bb68537a3455578a.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/hamburger.svg
// module id = 835
// module chunks = 0